var SamplingViewController = (function () {
    function SamplingViewController(env, $filter, $stateParams, $state, socket, $scope, settings, admin, Dialog, config) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.settings = settings;
        this.admin = admin;
        this.Dialog = Dialog;
        this.config = config;
        this.table = { filters: { cty: '' }, visible: 0 };
        this.rates = [{ k: 'rev0to25', v: '0 - 25 K' }, { k: 'rev25to50', v: '25 - 50 K' }, { k: 'rev50to100', v: '50 - 100 K' }, { k: 'rev100to500', v: '100 - 500 K' }, { k: 'rev500to1000', v: '500 - 1000 K' }, { k: 'rev1000andUp', v: 'over 1000 K' }];
        this.events = { beingSaved: false, serverErrors: undefined, viewBase: false };
        this.alphabet = { full: 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split(''), act: [], selected: '' };
        this.countriesLoaded = false;
        this.sourceLoaded = false;
        //        this.gmuList = [{ value: 'Y', text: 'Yes' }, { value: 'N', text: 'No' }];
        this.riskLevelList = [{ value: 'highRisk', text: 'High Risk' }, { value: 'lowStRisk', text: 'Low/Std Risk' }];
        this.samplingRateList = [{ value: 'baseline', text: 'Baseline' }, { value: 'lowFrequency', text: 'Low Frequency' }, { value: 'highFrequency', text: 'High Frequency' }];
        // Listener for successfully saved the country profile
        this.socket.forward('samplingview.ctySamplingSave', this.$scope);
        this.$scope.$on('socket:samplingview.ctySamplingSave', function (event, data) {
            _this.events.beingSaved = false; // turn off the being saved flag
            if (data.err) {
                // Update errors section for user
                _this.events.serverErrors = data.err;
            }
        });
        // Listener for successfully saved the base profile
        this.socket.forward('samplingview.baseSamplingSave', this.$scope);
        this.$scope.$on('socket:samplingview.baseSamplingSave', function (event, data) {
            _this.events.beingSaved = false; // turn off the being saved flag
        });
        // Listener for initial pull for countries
        this.socket.forward('samplingview.getCtySampling', this.$scope);
        this.$scope.$on('socket:samplingview.getCtySampling', function (event, data) {
            _this.prepareCtyForEdit(data); // Prepare the data for display
            _this.samplingCountries = data; // dump it
            _this.activateLetter('A'); // set index to A
            _this.countriesLoaded = true; // set flag to show
        });
        // Listener for source/base data
        this.socket.forward('samplingview.getSourceSampling', this.$scope);
        this.$scope.$on('socket:samplingview.getSourceSampling', function (event, data) {
            _this.prepareBaseForEdit(data.ratingSource);
            _this.riskSamplingSource = data.ratingSource;
            _this.sourceLoaded = true;
        });
    }
    /**
     * Function for when a letter is clicked on the index list
     * @param letter
     */
    SamplingViewController.prototype.activateLetter = function (letter) {
        var _this = this;
        if (this.alphabet.act.indexOf(letter) < 0) {
            return; // do nothing...
        }
        this.alphabet.selected = letter;
        this.table.visible = 0;
        angular.forEach(this.samplingCountries, function (samp) {
            if (samp.cty.substring(0, 1).toUpperCase() === letter.toUpperCase()) {
                samp.show = true;
                _this.table.visible++;
            }
            else {
                samp.show = false;
            }
        });
    };
    /**
     * Function to generate a country setting for all countries that do not have a Sampling entry
     */
    SamplingViewController.prototype.createMissingCountries = function (event) {
        var _this = this;
        var count = 0;
        var tit = 'Create Missing Countries';
        var items = {
            icon: 'QUESTION',
            message: 'Use this option to create profile for all countries that are not listed below. &nbsp;Continue?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                // Get array of the shortnames
                var shortNames_1 = _this.samplingCountries.map(function (sampCty) {
                    if (sampCty.cc) {
                        return sampCty.cc; // Pull country name
                    }
                    else {
                        // If no country code, add it
                        sampCty.cc = _this.config.getCountryByName(sampCty.cty);
                        return sampCty.cc;
                    }
                });
                angular.forEach(_this.settings.country_list, function (cty) {
                    // If entry is a country (and not IOT/IMT) and name is not already listed
                    if (cty.ic === 'Country' && shortNames_1.indexOf(cty.cc) < 0) {
                        // Create entry for country
                        _this.samplingCountries.push(_this.getNewCtry(cty.country, cty.short));
                        count++;
                    }
                });
                var mess = count > 0 ? '<b>' + count + '</b> new Countries added.  Please update the necessary fields.' : 'All Countries already have a Sampling Profile';
                items = {
                    icon: 'INFO',
                    message: mess,
                    title: tit
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (whatevs) { return; });
            }
        });
    };
    /**
     * Function to delete all periods in the country list whose end date is in the past
     * @param event
     */
    SamplingViewController.prototype.massDeleteExpired = function (event) {
        var _this = this;
        var count = 0;
        var tit = 'Mass Delete All Expired Periods';
        var items = {
            icon: 'QUESTION',
            message: 'Use this option to mass delete all Country Periods whose range is in the past.' +
                '<p><p><b>NOTE: &nbsp;</b>Only Countries with more than one Period will be checked. &nbsp;Continue?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                var today_1 = new Date().getTime();
                angular.forEach(_this.samplingCountries, function (cty) {
                    var newp = [];
                    // Only consider if more than one period
                    if (cty.periods.length > 1) {
                        for (var _i = 0, _a = cty.periods; _i < _a.length; _i++) {
                            var period = _a[_i];
                            // If the end date is less than today...
                            var pdate = new Date(period.edate_dp);
                            if (pdate.getTime() < today_1) {
                                count++;
                            }
                            else {
                                newp.push(period);
                            }
                        }
                        // If there are valid ones
                        if (newp.length > 0) {
                            cty.periods = newp; // Replace with valid ones
                        }
                        else {
                            cty.periods = [cty.periods[cty.periods.length - 1]];
                            count--;
                        }
                    }
                });
                var mess = count > 0 ? '<b>' + count + '</b> expired Periods successfully deleted. &nbsp;Remember to Save.' : 'There are no expired Periods to be deleted.';
                items = {
                    icon: 'INFO',
                    message: mess,
                    title: tit
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (whatevs) { return; });
            }
        });
    };
    /**
     * Function to add a new entry to every country based on the last one...but a year on
     * @param event
     */
    SamplingViewController.prototype.massUpdateAdd = function (event) {
        var _this = this;
        var count = 0;
        var tit = 'Mass Update New Periods';
        var items = {
            icon: 'QUESTION',
            message: 'Use this option to add a new Period for every country en-masse. &nbsp;The new Period\'s Start and End Date will be a year on from the last. &nbsp;Continue?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                angular.forEach(_this.samplingCountries, function (cty) {
                    _this.createPeriod(cty);
                    count++;
                });
                items = {
                    icon: 'INFO',
                    message: '<b>' + count + '</b> new Periods successfully added.',
                    title: tit
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (whatevs) { return; });
            }
        });
    };
    /**
     * Function to prepare the server data for display, ie: convert timestamps to Dates etc
     * @param ctryData
     */
    SamplingViewController.prototype.prepareCtyForEdit = function (ctryData) {
        var _this = this;
        angular.forEach(ctryData, function (ctry) {
            // Set the date-pickers up
            angular.forEach(ctry.periods, function (period) {
                period.sdate_dp = new Date(period.sdate);
                period.edate_dp = new Date(period.edate);
                period.finalRates = _this.convertRates(period.finalRates);
            });
            // Fix the index
            if (_this.alphabet.act.indexOf(ctry.cty.substring(0, 1).toUpperCase()) < 0) {
                _this.alphabet.act.push(ctry.cty.substring(0, 1).toUpperCase());
            }
            _this.alphabet.act.sort();
        });
    };
    /**
     * Function to prepare the server data for display, ie: numbers to full numbers
     * @param baseData
     */
    SamplingViewController.prototype.prepareBaseForEdit = function (baseData) {
        var _this = this;
        angular.forEach(baseData, function (base) {
            angular.forEach(base, function (risk) {
                angular.forEach(risk, function (v, k) {
                    risk[k] = _this.convertRate(v);
                });
            });
        });
    };
    SamplingViewController.prototype.$onInit = function () {
        this.admin.getAllCtySamples(); // Get the country data
        this.admin.getBaseSamples(); // Get the base data
    };
    /**
     * Function fired when user clicks save for country data
     */
    SamplingViewController.prototype.saveCountryData = function () {
        this.events.beingSaved = true; // Set flag to disable buttons
        delete this.events.serverErrors; // Delete any previous errors
        this.admin.updateAllCtySamples(this.samplingCountries); // Make call to server
    };
    /**
     * Function fired when user clicks save for base data
     */
    SamplingViewController.prototype.saveBaseData = function () {
        this.events.beingSaved = true; // Set flag to disable buttons
        this.admin.updateBaseSamples(this.riskSamplingSource); // Make call to server
    };
    /**
     * Function to refesh the country profiles should the base rates change
     * @param samp
     * @param risk
     * @param rate
     */
    SamplingViewController.prototype.baseChange = function (samp, risk, rate) {
        var _this = this;
        angular.forEach(this.samplingCountries, function (cty) {
            angular.forEach(cty.periods, function (period) {
                // If we have a match
                if (period.riskLevel === risk && period.samplingRate === samp) {
                    if (period.override) {
                        // If it's overriden, lose the override details
                        if (_this.riskSamplingSource[samp][risk][rate] === period.finalRates[rate]) {
                            delete period.override;
                        }
                    }
                    else {
                        period.finalRates[rate] = _this.riskSamplingSource[samp][risk][rate]; // Overwrite
                    }
                }
            });
        });
    };
    SamplingViewController.prototype.getCurrentPeriod = function () {
        // Set dates based on today's date...if in 2018... set as 1st Jan to 31st Dec
        var pds = {};
        var sd = new Date();
        var ed = new Date();
        sd.setFullYear(new Date().getFullYear(), 0, 1);
        ed.setFullYear(new Date().getFullYear(), 11, 31);
        pds.sd = sd;
        pds.ed = ed;
        return pds;
    };
    /**
     * Function to create a new country object with a single period
     * @param name
     * @param short
     */
    SamplingViewController.prototype.getNewCtry = function (name, short) {
        var dates = this.getCurrentPeriod();
        var cty = {
            cty: name,
            cc: short,
            periods: [
                {
                    GMU: '',
                    sdate: dates.sd.getTime(),
                    edate: dates.ed.getTime(),
                    sdate_dp: dates.sd,
                    edate_dp: dates.ed,
                    riskLevel: '',
                    samplingRate: ''
                },
            ]
        };
        // Set final rates based on above default settings - only if default settings are used
        // cty.periods[0].finalRates = this.convertRates(angular.copy(this.riskSamplingSource.lowFrequency.highRisk));
        // If no defaults, just set as ''
        var period = {};
        angular.forEach(this.rates, function (v, k) {
            period[k] = ''; // Set as nothing
        });
        cty.periods[0].finalRates = period;
        // If should be visible, show it
        if (name.substring(0, 1).toUpperCase() === this.alphabet.selected) {
            cty.show = true;
            this.table.visible++;
        }
        else {
            cty.show = false;
        }
        // Refresh the index
        if (this.alphabet.act.indexOf(cty.cty.substring(0, 1).toUpperCase()) < 0) {
            this.alphabet.act.push(cty.cty.substring(0, 1).toUpperCase());
        }
        this.alphabet.act.sort();
        return cty;
    };
    /**
     * Function to check if a period's percentages have been changed by a user and differ from the base rates
     * @param period
     */
    SamplingViewController.prototype.checkForOverride = function (period) {
        var _this = this;
        var orchange = false;
        // If someone updates one of the %, perform this check to set the 'edited' flag
        angular.forEach(period.finalRates, function (v, k) {
            // If the value in the field doesn't match the base value
            if (period.finalRates[k] !== _this.riskSamplingSource[period.samplingRate][period.riskLevel][k]) {
                // If no override details for period at all...
                if (angular.isUndefined(period.override)) {
                    // create an object
                    period.override = {};
                    orchange = true;
                }
                else {
                    // if already set for this rate
                    if (period.override[k]) {
                        // check if the value has changed
                        if (period.finalRates[k] !== period.override[k].cv) {
                            // If they have overwrite the user
                            orchange = true;
                        }
                    }
                    else {
                        orchange = true;
                    }
                }
                // Add override details for perc
                if (orchange) {
                    period.override[k] = { cv: period.finalRates[k], who: _this.env.user.email, when: new Date() };
                    orchange = false; // reset
                }
            }
            else {
                // If the same as base...delete any overrides for that perc
                if (angular.isDefined(period.override)) {
                    delete period.override[k]; // If previously flagged as overridden, wipe it
                }
            }
        });
        // If overridden still exists, check it still has props
        if (angular.isDefined(period.override) && Object.keys(period.override).length === 0) {
            delete period.override; // If no elements overridden, delete the section completely
        }
    };
    // Display override update when hovering over the exclamation mark
    SamplingViewController.prototype.getTitle = function (period, rate) {
        var base = this.riskSamplingSource[period.samplingRate][period.riskLevel][rate];
        return 'This percentage differs from the current base rate of ' + base +
            '.  It was last updated by:\n\n'
            + period.override[rate].who + ' on ' + period.override[rate].when + '.';
    };
    /**
     * Function to check if a change has been made to the sampling rate or risk level and to update
     * values accordingly if so
     * @param period
     */
    SamplingViewController.prototype.reevaluateCty = function (period) {
        //const guys: string[][] = [['GMU', 'newGMU'], ['riskLevel', 'newRiskLevel'], ['samplingRate', 'newSamplingRate']];
        var guys = [['riskLevel', 'newRiskLevel'], ['samplingRate', 'newSamplingRate']];
        // Check if there's been a change
        var change = false;
        angular.forEach(guys, function (guy) {
            if (angular.isDefined(period[guy[1]]) && period[guy[0]] !== period[guy[1]]) {
                change = true;
            }
        });
        // If so...
        if (change) {
            period.GMU = period.newGMU;
            period.riskLevel = period.newRiskLevel;
            period.samplingRate = period.newSamplingRate;
            // And all the source data is available...
            if (typeof this.riskSamplingSource !== 'undefined' && typeof this.riskSamplingSource[period.samplingRate] !== 'undefined' && typeof this.riskSamplingSource[period.samplingRate][period.riskLevel] !== 'undefined') {
                // Replace it...
                //period.finalRates = this.convertRates(angular.copy(this.riskSamplingSource[period.samplingRate][period.riskLevel]));
                period.finalRates = angular.copy(this.riskSamplingSource[period.samplingRate][period.riskLevel]);
            }
        }
        this.checkForOverride(period);
    };
    SamplingViewController.prototype.convertRate = function (v) {
        return (v * 100).toFixed(0); // Convert to text
    };
    SamplingViewController.prototype.convertRates = function (finalRates) {
        angular.forEach(finalRates, function (v, k) {
            finalRates[k] = (v * 100).toFixed(0); // Convert to text
        });
        return finalRates;
    };
    /**
     * openActionMenu - Launch action menu dropdown using MD functions
     *
     * @param  {type} $mdOpenMenu: any ngMaterials open menu object
     * @param  {type} event: any       browser event
     */
    SamplingViewController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    /**
     * Function to append a new period to a country - will simply copy the previous one
     * but shift the year on
     * @param cty
     */
    SamplingViewController.prototype.addPeriod = function (cty) {
        var _this = this;
        angular.forEach(this.samplingCountries, function (samp) {
            if (samp.cty === cty) {
                _this.createPeriod(samp);
            }
        });
    };
    SamplingViewController.prototype.createPeriod = function (country) {
        var period = angular.copy(country.periods[country.periods.length - 1]);
        // Set the dates to the next year, assuming that's is what will be required
        var startDate = new Date(period.sdate_dp);
        var endDate = new Date(period.edate_dp);
        startDate.setFullYear(startDate.getFullYear() + 1);
        endDate.setFullYear(endDate.getFullYear() + 1);
        period.sdate = startDate.getTime();
        period.edate = endDate.getTime();
        period.sdate_dp = startDate;
        period.edate_dp = endDate;
        country.periods.push(period);
    };
    SamplingViewController.prototype.deletePeriod = function (ev, sample, p_index) {
        var _this = this;
        // Only allow if there's more than one for this country - disabled...but if someone's naughty
        if (sample.periods.length < 2) {
            return;
        }
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure you want to Delete this Country Period?',
            title: 'Delete Country Period'
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult) {
                // Find the entry and lose it
                angular.forEach(_this.samplingCountries, function (samp) {
                    if (samp.cty === sample.cty) {
                        samp.periods.splice(p_index, 1);
                    }
                });
            }
        });
    };
    SamplingViewController.$inject = ['env', '$filter', '$stateParams', '$state',
        'socket', '$scope', 'settings', 'admin', 'Dialog', 'config'];
    return SamplingViewController;
}());
var SamplingViewComponent = (function () {
    function SamplingViewComponent() {
        this.templateUrl = 'sampling-view.html';
        this.controllerAs = 'vm';
        this.controller = SamplingViewController;
    }
    return SamplingViewComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg');
})
    .component('viewSamplingSection', new SamplingViewComponent());

//# sourceMappingURL=sampling.view.component.js.map
